import React from 'react';
import styled from 'styled-components';
import { StyledRow } from 'helpers/StyledLoginComponentsHelper';
import { getTranslatedString } from 'helpers/i18n';
import { BounceLoader } from 'halogenium';
import { AccentColor } from 'helpers/AccentColorHelper';

const StyledH3 = styled.h3`
  text-align: center;
  color: ${props => (props.img ? '#f4f4f4' : '#4e4e4e')};
`;

const StyledBounceLoader = styled(BounceLoader)``;

const StyledColumn = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  flex: auto;
  justify-content: center;
  align-items: center;
`;

export default props => {
  return (
    <StyledRow>
      <StyledColumn>
        <StyledBounceLoader color={AccentColor()} />
        <StyledH3 img={props.img}>{getTranslatedString('login.loggingIn')}</StyledH3>
      </StyledColumn>
    </StyledRow>
  );
};
